import { useEffect } from "react";
import { TAGLINE, COMPANY_CORE_THOUGHT } from "../data";

const BASE = `NeuraVolt | ${TAGLINE}`;
function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function removeMeta(attr, key) {
  const el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.remove();
}

export const Seo = ({ title, description, keywords, path = "", image, jsonLd }) => {
  useEffect(() => {
    // Deduplicate NeuraVolt brand suffix if already present in title
    let fullTitle;
    if (!title) {
      fullTitle = BASE;
    } else if (/neuravolt/i.test(title)) {
      fullTitle = title.trim();
    } else {
      fullTitle = `${title.trim()} | NeuraVolt`;
    }
    document.title = fullTitle;

    const desc = description || COMPANY_CORE_THOUGHT || "NeuraVolt delivers intelligent solutions and measurable impact across one connected digital ecosystem.";

    // Normalize canonical URL generation (trim redundant slashes, handle root vs internal routes)
    const cleanPath = path ? (path.startsWith("/") ? path : `/${path}`).replace(/\/+$/, "") : "";
    const url = cleanPath ? `https://neuravolt.in${cleanPath}` : "https://neuravolt.in/";

    setMeta("name", "description", desc);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1");

    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", "Neuravolt");
    setMeta("property", "og:locale", "en_IN");

    if (image && !image.includes("og-image.png")) {
      setMeta("property", "og:image", image);
      setMeta("property", "og:image:width", "1200");
      setMeta("property", "og:image:height", "630");
      setMeta("name", "twitter:image", image);
      setMeta("name", "twitter:image:alt", fullTitle);
    } else {
      removeMeta("property", "og:image");
      removeMeta("property", "og:image:width");
      removeMeta("property", "og:image:height");
      removeMeta("property", "og:image:alt");
      removeMeta("name", "twitter:image");
      removeMeta("name", "twitter:image:alt");
    }

    setMeta("name", "twitter:card", "summary");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    canonical.setAttribute("href", url);

    let script = document.getElementById("nv-jsonld");
    if (jsonLd) {
      if (!script) { script = document.createElement("script"); script.type = "application/ld+json"; script.id = "nv-jsonld"; document.head.appendChild(script); }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) { script.remove(); }
  }, [title, description, keywords, path, image, jsonLd]);

  return null;
};

export default Seo;
